import "../styles/footer.css";
import { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { fetchBusinessData } from "../features/business/business_slice";

function Footer() {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const data = useSelector((state) => state.business.data);
  const loading = useSelector((state) => state.business.loading);

  const handleNavigate = () => {
    navigate("/about", {
      state: { aData: data.about_us },
    });
  };

  const handleNavigateTerms = () => {
    navigate("/terms", {
      state: { aData: data.terms },
    });
  };

  useEffect(() => {
    if (loading) dispatch(fetchBusinessData());
  }, [loading, dispatch]);

  if (!data) {
    return <></>;
  }
  return (
    <footer className="footer">
      <img
        src={`${process.env.PUBLIC_URL}/logo.png`}
        alt="Logo"
        className="footer-logo"
      />

      <div className="contact-info">
        <p>Email: {data.email}</p>
        <p>Phone: {data.phone}</p>
      </div>

      <div className="footer-links">
        <button className="text-button" onClick={handleNavigate}>
          About Us
        </button>
        <button className="text-button" onClick={handleNavigateTerms}>
          Terms & Conditions
        </button>
      </div>

      <div className="social-icons">
        <a href={data.facebook} target="_blank" rel="noreferrer">
          <i className="fab fa-facebook"></i>
        </a>
        <a href={data.twitter} target="_blank" rel="noreferrer">
          <i className="fab fa-twitter"></i>
        </a>
        <a href={data.instagram} target="_blank" rel="noreferrer">
          <i className="fab fa-instagram"></i>
        </a>
        <a href={data.youtube} target="_blank" rel="noreferrer">
          <i className="fab fa-youtube"></i>
        </a>
        <a href={data.linkedin} target="_blank" rel="noreferrer">
          <i className="fab fa-linkedin"></i>
        </a>
      </div>
    </footer>
  );
}

export default Footer;
